import React from 'react';
import ReactDOM from 'react-dom';
import TripResults from './tripresults.js';

document.addEventListener("DOMContentLoaded", function() {

  if (document.getElementById('tripresults')) {
    ReactDOM.render(
      <TripResults></TripResults>,
      document.getElementById('tripresults')
    );
  }

})
